export const HW_APP_TYPE = "hardware";

export enum HwEventType {
	EVENTS = "events",
	PERCENTAGE = "percentage",
	DURATION = "duration",
	SCORE = "score",
}
